import React from 'react';
import { CheckIcon } from 'lucide-react';
const badges = ['Hotmart verificado', 'Contenido basado en regulaciones oficiales OACI', 'Garantía de dinero de vuelta (7 días)', 'Español neutro, válido en toda LATAM'];
export function SiteFooter() {
  return <footer className="w-full bg-ink-950 py-14 text-white" data-id="element-185" data-mp="3mfg90lrg5n4v">
      <div className="mx-auto max-w-content px-6" data-id="element-186" data-mp="3hheri59o5vvi">
        <ul className="grid gap-3 border-b border-white/10 pb-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-187" data-mp="3hglqlkxe60la">
          {badges.map(badge => <li key={badge} className="flex items-start gap-2 text-sm text-white/70" data-id="element-188" data-mp="38i1dczaloj4g">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flare-500" aria-hidden="true" data-id="element-189" data-mp="33iou0oixtu6m" />
              <span data-id="element-190" data-mp="2yjlneznb7fwj">{badge}</span>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col gap-6 text-sm text-white/50 lg:flex-row lg:items-center lg:justify-between" data-id="element-191" data-mp="2yl560wwfu31h">
          <div data-id="element-192" data-mp="11p7lzjqwarbc">
            <p className="font-bold text-white" data-id="element-193" data-mp="ws7h3c5s7ult">© 2026 Drone Commander</p>
            <p className="mt-1" data-id="element-194" data-mp="wq4i42mnir4y">Todos los derechos reservados</p>
            <p className="mt-1" data-id="element-195" data-mp="15ptuenoxfits">
              Plataforma de entrega: Hotmart · Regulaciones de Aviación Civil LATAM 2026
            </p>
          </div>
          <nav aria-label="Enlaces legales" className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-196" data-mp="vsp7umr65lcg">
            <a href="#terminos" className="transition-colors duration-150 ease-swift hover:text-flare-500" data-id="element-197" data-mp="10rseucqpm1n2">
              Términos de uso
            </a>
            <a href="#privacidad" className="transition-colors duration-150 ease-swift hover:text-flare-500" data-id="element-198" data-mp="1oio535fioos7">
              Política de privacidad
            </a>
            <a href="mailto:soporte@dronecommander.lat" className="transition-colors duration-150 ease-swift hover:text-flare-500" data-id="element-199" data-mp="1es35pfs0rg88">
              soporte@dronecommander.lat
            </a>
          </nav>
        </div>

        <p className="mt-8 text-xs text-white/35" data-id="element-200" data-mp="27f62o3h1riwd">
          Hecho para amantes de los drones que quieren aprender a hacerlo bien desde el inicio.
        </p>
      </div>
    </footer>;
}